/**
 * ENTITY values are being used in allowedFormats
 */
export const ENTITY = {
  SHORTCODE_PREFIX: 'SHORTCODE:',
  URL: 'URL',
  EMAIL: 'Email',
  IMAGE: 'Image',
  CC: 'CreditCard',
  PHONE: 'Phone',
  TERM: 'Term'
}
